// Colored square badge (rbd-cmms craft-badge style) for the Returned Rolls
// Status column. Maps the SP's single Status value to a square + initial.
export interface StatusMeta {
	letter: string;
	color: string;
	label: string;
}

export const STATUS_BY_VALUE: Record<string, StatusMeta> = {
	Returned: { letter: "R", color: "#16a34a", label: "Returned" }, // green
	Scrapped: { letter: "S", color: "#dc2626", label: "Scrapped" }, // red
	Broken: { letter: "B", color: "#d97706", label: "Broken" }, // amber
};

interface SquareProps {
	letter: string;
	color: string;
	title?: string;
	size?: number;
}

export const StatusSquare = ({
	letter,
	color,
	title,
	size = 22,
}: SquareProps) => (
	<div
		title={title}
		style={{
			height: size,
			width: size,
			borderRadius: 4,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			background: color,
			flexShrink: 0,
		}}
	>
		<span style={{ color: "#fff", fontWeight: 600, fontSize: "0.8rem" }}>
			{letter}
		</span>
	</div>
);
